<app-header></app-header>
<div class="bg-[#F8F8F8] h-[calc(100vh-72px)] flex flex-col items-center justify-center">
  <img src="./assets/images/img-not-found.svg" alt="" />
  <p class="text-2xl font-bold text-neutral/1">Không tìm thấy trang</p>
</div>